import { FadeUp } from './Motion.jsx';
import { IconShield } from './Icons.jsx';

export default function SafetyNotice({ title, children, linkLabel, linkHref }) {
  return (
    <FadeUp>
      <section className="safety-note" aria-label={title}>
        <span className="safety-note-icon" aria-hidden="true"><IconShield /></span>
        <div>
          <h2 className="safety-note-title">{title}</h2>
          <div className="safety-note-text">{children}</div>
          {linkHref && (
            <a className="safety-note-link" href={linkHref} target="_blank" rel="noopener noreferrer">
              {linkLabel} <span aria-hidden="true">&rarr;</span>
            </a>
          )}
        </div>
      </section>
    </FadeUp>
  );
}